import { currencyValueToLocaleString } from "@/utils/currencyValueToLocaleString";

/** Converte reais em centavos inteiros; retorna null para valores inválidos. */
export function parseReaisToCents(value: string): number {
  const input = value.trim();
  const parts =
    /^(\d+|\d{1,3}(?:\.\d{3})+)(?:,(\d{1,2}))?$/.exec(input) ??
    /^(\d*)[.,](\d{1,2})$/.exec(input);

  if (!parts) return null;

  const reais = (parts[1] || "0").replace(/\./g, "");
  const decimals = (parts[2] ?? "").padEnd(2, "0");
  const cents = Number(`${reais}${decimals}`);

  return Number.isSafeInteger(cents) ? cents : null;
}

/** Formata centavos inteiros para edição em reais, com vírgula decimal. */
export function formatCentsToInput(cents: number): string {
  const digits = String(cents).padStart(3, "0");

  return `${digits.slice(0, -2)},${digits.slice(-2)}`;
}

/** Formata o custo em centavos como moeda brasileira para exibição. */
export function formatCentsToCurrency(cents: number): string {
  return currencyValueToLocaleString(cents / 100);
}
